var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartCardReader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 14.667,
    viewBox: "0 0 25 14.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b,.d{fill:none;}.a,.b{stroke:#496482;stroke-miterlimit:10;stroke-width:2px;}.b{stroke-linecap:round;}.c{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-367 -440)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(373.667 440)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 12.667,
    height: 14.667,
    rx: 4.054
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 1,
    y: 1,
    width: 10.667,
    height: 12.667,
    rx: 3.054
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(367 442.667)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 8,
    height: 9.333,
    rx: 1.911
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 1,
    y: 1,
    width: 6,
    height: 7.333,
    rx: 0.911
  })), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 5.333,
    transform: "translate(385.667 447.333)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartCardReader);
export default __webpack_public_path__ + "static/media/smart-card-reader.2682aed9bd1e4745da28b7e6af9e3929.svg";
export { ForwardRef as ReactComponent };